import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import { FormControl, FormAutocomplete } from 'components/ui';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import { getFormattedCountriesArr } from 'lib/utils/getCountriesList';

export default function PlaceOfBirth({ isRequired = true }) {
  const { t } = useTranslation();

  const countriesArr = getFormattedCountriesArr();

  return (
    <Accordion
      startAdornment={<CakeOutlinedIcon />}
      title={t('Place of birth') + (isRequired ? ' *' : '')}
    >
      <FormControl label={t('Address line')}>
        <STextField
          name="birthPlace.address"
          placeholder={t('Address line')}
          dataId="place-of-birth-input"
        />
      </FormControl>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('City') + (isRequired ? ' *' : '')}>
          <STextField
            name="birthPlace.city"
            placeholder={t('City')}
            dataId="place-of-birth-input"
          />
        </FormControl>
        <FormControl label={t('Postal code')}>
          <STextField
            name="birthPlace.zipcode"
            placeholder={t('Postal code')}
            dataId="place-of-birth-input"
          />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('State')}>
          <STextField
            name="birthPlace.state"
            placeholder={t('State')}
            dataId="place-of-birth-input"
          />
        </FormControl>
        <FormControl label={t('Country') + (isRequired ? ' *' : '')}>
          <FormAutocomplete
            name="birthPlace.country"
            data-id="country-input"
            options={countriesArr}
            getOptionValue={(option) => option?.name?.name || ''}
            getOptionLabel={(option) => option?.name?.name || ''}
            placeholder={t('Country')}
          />
        </FormControl>
      </MuiBox>
    </Accordion>
  );
}
